declare global {
  interface Window {
    betterstack: any;
  }
}

export const track = (
  event: string,
  properties?: Record<string, unknown>
): void => {
  if (typeof window !== 'undefined' && window.betterstack) {
    window.betterstack('track', event, properties);
  }
};

export const trackLinks = (
  selector: string,
  event: string,
  properties?: Record<string, unknown>
): void => {
  if (typeof window === 'undefined') return;

  document.querySelectorAll(selector).forEach((el) => {
    el.addEventListener('click', () => track(event, properties));
  });
};
